const $ = require('jquery');

module.exports = class QuoteCarouselHeightSetter {
  constructor() {
    setInterval(() => {
      if (window.innerWidth < 750) {
        return
      }

      const slides = $('.itbl-c-quote-carousel__wrapper.slick-slide');
      const $quoteCarouselText = $('[data-component="quote-carousel-quote-text"]');

      let maxHeight = 0;
      $quoteCarouselText.each((i, e) => {
        const height = e.getBoundingClientRect().height;
        maxHeight = height > maxHeight ? height : maxHeight;
      });

      $quoteCarouselText.css('height', maxHeight);

      if (slides.length) {
        slides.addClass('w-100p-important');
      }
    }, 300);

    $(window).on('resize', () => {
      const $quoteCarouselText = $('[data-component="quote-carousel-quote-text"]');
      $quoteCarouselText.css('height', 'unset');
    });
  }
}